import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CacheStorageAdapter } from '@barthauer/abc/core/data';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { BasysMapFrameService } from '@barthauer/basys/map-frame';
import { Observable, Subject } from 'rxjs';
import { startWith, switchMap, tap } from 'rxjs/operators';
import { MtTicketCounterHelper } from '../models/mtData.tickets.model';
import { AppService } from '../services/app.service';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-ticket-selection',
  templateUrl: './ticket-selection.component.html',
  styleUrls: ['./ticket-selection.component.scss'],
  standalone: false,
})
export class TicketSelectionComponent implements OnInit {
  public ticketCounterObservable$: Observable<MtTicketCounterHelper>;
  private readonly refreshSubject$ = new Subject<void>();

  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;
  public loading: boolean;
  private _isDownloaded: boolean;

  constructor(
    private resourceService: ResourceManagerService,
    private dataService: DataService,
    public appService: AppService,
    private frame: BasysMapFrameService,
    private cdr: ChangeDetectorRef,
  ) {
    this.resAsync = this.resourceService.getResourceSet('abc-maintenance-opera');

    this.ticketCounterObservable$ = this.refreshSubject$.pipe(
      startWith(undefined),
      switchMap(() => this.dataService.getMtTicketsCountHelper()),
      tap(() => (this.loading = false)),
    );
  }

  async ngOnInit() {
    this.res = await this.resAsync;
    this._isDownloaded = await this.appService.isTicketsDownloadedAsync();
    if (this._isDownloaded) {
      this.cdr.detectChanges();
    }
  }

  public selectTicketMode(): void {
    this.appService.loadTicketsAsync().then(() => {
      this.frame.routing.navigate(this.frame.rootRoute);
    });
  }

  public get isDownloaded(): boolean {
    return this._isDownloaded;
  }

  public get canSelect(): boolean {
    return this.isDownloaded || !CacheStorageAdapter.useOfflineMode || !CacheStorageAdapter.isDownloadComplete;
  }
}
